





















































import { Component, Vue } from 'vue-property-decorator'
import { namespace } from 'vuex-class'
const narrowcasting = namespace('narrowcasting')

@Component
export default class CompanySettingsNarrowcasting extends Vue {
    @narrowcasting.State readonly loading!: boolean
    @narrowcasting.State readonly saving!: boolean
    @narrowcasting.Action readonly loadData: () => Promise<void>

    async mounted(): Promise<void> {
        await this.loadData()
    }
}
